import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Video() {
    return (
        <>
<FontAwesomeIcon icon="fa-solid fa-video" style={{ color: '#000000', fontSize: '26px', padding:'4px'}} />

  
      
      </>
    )
  }
  
  export default Video